var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.78378 0C3.78983 0 0.540527 3.2493 0.540527 7.24321C0.540527 12.1998 7.02253 19.4763 7.2985 19.7837C7.55772 20.0724 8.0103 20.0719 8.26905 19.7837C8.54503 19.4763 15.027 12.1998 15.027 7.24321C15.0269 3.2493 11.7777 0 7.78378 0Z",
    fill: "#FF0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.2bdaba363bda621e708e9ad69370cb7c.svg";
export { ForwardRef as ReactComponent };